// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../errorBanner.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Component Title --- */
.AddUsers_stepTitle__Gqp9n {
  font-size: 1.8rem;
  font-weight: 600;
  color: var(--primary-dark-blue);
  margin-bottom: 15px;
  text-align: center;
}

.AddUsers_stepSubtitle__2mmXa {
  font-size: 1.1rem;
  font-weight: 400;
  color: var(--primary-dark-blue);
  text-align: center;
  margin-top: -10px;
  margin-bottom: 25px;
  line-height: 1.5;
}

/* --- Table & Add User Button --- */
.AddUsers_tableContainer__0MOjn {
  margin-top: 20px;
}

.AddUsers_addUserButtonContainer__JiPVQ {
  margin-top: 20px;
  text-align: center;
}

/* Primary CTA — matches the Continue button in the nav footer so all
   call-to-action buttons read the same (and differently from status chips) */
.AddUsers_addUserButton__trU0v {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 24px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--neutral-white);
  background-color: var(--secondary-bright-blue);
  border: 1px solid var(--secondary-bright-blue);
}

.AddUsers_addUserButton__trU0v:hover {
  background-color: var(--primary-dark-blue);
  border-color: var(--primary-dark-blue);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

/* --- Modal Form Inputs --- */
.AddUsers_inputGrid__2K4Uy {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
}

/* Stack First/Last name to full width on mobile (desktop modal stays two-up) */
@media (max-width: 768px) {
  .AddUsers_inputGrid__2K4Uy {
    grid-template-columns: 1fr;
  }
}

.AddUsers_inputGroup__gFC8A {
  margin-bottom: 25px;
}

.AddUsers_inputGroup__gFC8A label {
  display: block;
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
}
.AddUsers_inputGroup__gFC8A input {
  box-sizing: border-box;
  width: 100%;
  padding: 12px 15px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 1rem;
  font-family: 'Poppins', sans-serif;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}
.AddUsers_inputGroup__gFC8A input:focus {
  outline: none;
  border-color: var(--secondary-bright-blue);
  box-shadow: 0 0 0 3px rgba(16, 162, 221, 0.2);
}

.AddUsers_errorMessage__J9sth {
  color: #e53e3e;
  font-size: 0.875rem;
  margin-top: 5px;
}

.AddUsers_inlineError__qlJFV {
}

.AddUsers_inlineErrorClose__kVqR3 {
}

/* --- Checkboxes --- */
.AddUsers_checkboxGroup__0NDXC {
  display: flex;
  flex-direction: row;
  gap: 50px;
  margin-top: 8px;
  border-radius: 8px;
  border: 1px solid #ccc;
  padding: 10px 15px;
}

/* Stack the role checkboxes on mobile so they aren't cramped side-by-side */
@media (max-width: 768px) {
  .AddUsers_checkboxGroup__0NDXC {
    flex-direction: column;
    gap: 14px;
  }
}

.AddUsers_checkboxLabel__rVHPY {
  display: flex;
  align-items: center;
  font-weight: normal;
  cursor: pointer;
}

.AddUsers_checkboxLabel__rVHPY input {
  width: auto;
  margin-right: 8px;
  cursor: pointer;
}

/* --- Modal Action Buttons (match the nav footer CTAs) --- */
.AddUsers_submitButton__cXOjH {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 24px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--neutral-white);
  background-color: var(--secondary-bright-blue);
  border: 1px solid var(--secondary-bright-blue);
}

.AddUsers_submitButton__cXOjH:hover {
  background-color: var(--primary-dark-blue);
  border-color: var(--primary-dark-blue);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.AddUsers_submitButtonIcon__GwOMv {
  font-size: 0.9em;
}

.AddUsers_secondaryButton__oojr5 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  padding: 0 24px;
  font-size: 1rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--primary-dark-blue);
  background-color: transparent;
  border: 1px solid #dbe1e8;
}

.AddUsers_secondaryButton__oojr5:hover {
  background-color: #f0f4f8;
}

/* Balanced, finger-friendly footer buttons on mobile */
@media (max-width: 768px) {
  .AddUsers_submitButton__cXOjH,
  .AddUsers_secondaryButton__oojr5 {
    flex: 1 1;
  }
}

/* --- Desktop Users Table (custom, lightweight) --- */
.AddUsers_userTable__60q-0 {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.95rem;
}

.AddUsers_userTable__60q-0 th {
  text-align: left;
  font-weight: 600;
  font-size: 0.8rem;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #6c757d;
  padding: 12px 14px;
  background-color: #f7f9fb;
  border-bottom: 1px solid #e0e0e0;
}

.AddUsers_userTable__60q-0 td {
  padding: 14px;
  border-bottom: 1px solid #eef0f2;
  vertical-align: middle;
  color: var(--primary-dark-blue);
}

.AddUsers_userTable__60q-0 tbody tr:last-child td {
  border-bottom: none;
}

.AddUsers_userTable__60q-0 tbody tr:hover {
  background-color: #f7f9fb;
}

/* First/Last/Phone stay on a single line (V2-761) */
.AddUsers_nameCell__iwvbN,
.AddUsers_phoneCell__cRwQB {
  white-space: nowrap;
}

.AddUsers_phoneCol__-X3fm,
.AddUsers_phoneCell__cRwQB {
  min-width: 150px;
}

.AddUsers_emailCell__-Mfjv {
  word-break: break-all;
  overflow-wrap: anywhere;
}

.AddUsers_badgeStack__NQmbJ {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
}

/* Actions column — icon buttons, clearly distinct from the status chips */
.AddUsers_actionsCol__5hODz {
  width: 96px;
}

.AddUsers_rowActions__XCYNi {
  display: flex;
  gap: 6px;
  justify-content: flex-end;
}

/* Filled icon buttons — edit = blue, delete = red (matching the mobile
   card actions), and clearly distinct from the pill status chips */
.AddUsers_iconButton__Rvav2 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--neutral-white);
  background-color: var(--secondary-bright-blue);
  border: 1px solid var(--secondary-bright-blue);
}

.AddUsers_iconButton__Rvav2:hover {
  background-color: var(--primary-dark-blue);
  border-color: var(--primary-dark-blue);
}

.AddUsers_iconButtonDelete__ooyRY {
  background-color: #e53e3e;
  border-color: #e53e3e;
}

.AddUsers_iconButtonDelete__ooyRY:hover {
  background-color: #c53030;
  border-color: #c53030;
}

/* --- Mobile card action buttons (edit = blue, delete = red) --- */
.AddUsers_cardActionButton__raCTC {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 44px;
  padding: 0 16px;
  font-size: 0.95rem;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--neutral-white);
  background-color: var(--secondary-bright-blue);
  border: 1px solid var(--secondary-bright-blue);
}

.AddUsers_cardActionButton__raCTC:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.AddUsers_cardActionButtonDelete__13\\+8Q {
  background-color: #e53e3e;
  border-color: #e53e3e;
}

.AddUsers_cardActionButtonDelete__13\\+8Q:hover {
  background-color: #c53030;
  border-color: #c53030;
}

/* --- Mobile User Cards (replaces the table on small screens) --- */
.AddUsers_userCardList__-et8F {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.AddUsers_userCard__IGeJu {
  background-color: var(--neutral-white);
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 14px 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.AddUsers_userCardHeader__o4atk {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 10px;
}

.AddUsers_userCardName__0q6q9 {
  font-weight: 600;
  font-size: 1.05rem;
  color: var(--primary-dark-blue);
  word-break: break-word;
}

.AddUsers_userCardBadges__e9Tgf {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
  flex-shrink: 0;
}

.AddUsers_userCardRow__JuMCY {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 5px 0;
  font-size: 0.95rem;
}

.AddUsers_userCardLabel__wZV-3 {
  color: #6c757d;
  flex-shrink: 0;
}

.AddUsers_userCardEmail__0YqFh {
  word-break: break-all;
  text-align: right;
}

.AddUsers_userCardActions__2OrOF {
  display: flex;
  gap: 10px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
}

.AddUsers_userCardActions__2OrOF button {
  flex: 1 1;
}

.AddUsers_emptyState__5NREZ {
  text-align: center;
  color: #6c757d;
  font-size: 0.95rem;
  padding: 28px 16px;
  border: 1px dashed #d5d9e0;
  border-radius: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/RegistrationForm/steps/AddUsers/AddUsers.module.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;6EAC6E;AAC7E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,8CAA8C;EAC9C,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,+EAA+E;AAC/E;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kCAAkC;EAClC,wDAAwD;AAC1D;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;AAEA;;AAEA;AAEA;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,4EAA4E;AAC5E;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA,6DAA6D;AAC7D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,8CAA8C;EAC9C,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,+BAA+B;EAC/B,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uDAAuD;AACvD;EACE;;IAEE,SAAO;EACT;AACF;;AAEA,sDAAsD;AACtD;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oDAAoD;AACpD;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;AACzB;;AAEA,0EAA0E;AAC1E;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;mEACmE;AACnE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,8CAA8C;EAC9C,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mEAAmE;AACnE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,8CAA8C;EAC9C,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":["/* --- Component Title --- */\n.stepTitle {\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: var(--primary-dark-blue);\n  margin-bottom: 15px;\n  text-align: center;\n}\n\n.stepSubtitle {\n  font-size: 1.1rem;\n  font-weight: 400;\n  color: var(--primary-dark-blue);\n  text-align: center;\n  margin-top: -10px;\n  margin-bottom: 25px;\n  line-height: 1.5;\n}\n\n/* --- Table & Add User Button --- */\n.tableContainer {\n  margin-top: 20px;\n}\n\n.addUserButtonContainer {\n  margin-top: 20px;\n  text-align: center;\n}\n\n/* Primary CTA — matches the Continue button in the nav footer so all\n   call-to-action buttons read the same (and differently from status chips) */\n.addUserButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 44px;\n  padding: 0 24px;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: var(--neutral-white);\n  background-color: var(--secondary-bright-blue);\n  border: 1px solid var(--secondary-bright-blue);\n}\n\n.addUserButton:hover {\n  background-color: var(--primary-dark-blue);\n  border-color: var(--primary-dark-blue);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n/* --- Modal Form Inputs --- */\n.inputGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 20px;\n}\n\n/* Stack First/Last name to full width on mobile (desktop modal stays two-up) */\n@media (max-width: 768px) {\n  .inputGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.inputGroup {\n  margin-bottom: 25px;\n}\n\n.inputGroup label {\n  display: block;\n  font-weight: 500;\n  margin-bottom: 8px;\n  color: #333;\n}\n.inputGroup input {\n  box-sizing: border-box;\n  width: 100%;\n  padding: 12px 15px;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  font-size: 1rem;\n  font-family: 'Poppins', sans-serif;\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\n}\n.inputGroup input:focus {\n  outline: none;\n  border-color: var(--secondary-bright-blue);\n  box-shadow: 0 0 0 3px rgba(16, 162, 221, 0.2);\n}\n\n.errorMessage {\n  color: #e53e3e;\n  font-size: 0.875rem;\n  margin-top: 5px;\n}\n\n.inlineError {\n  composes: inlineError from '../../errorBanner.module.css';\n}\n\n.inlineErrorClose {\n  composes: inlineErrorClose from '../../errorBanner.module.css';\n}\n\n/* --- Checkboxes --- */\n.checkboxGroup {\n  display: flex;\n  flex-direction: row;\n  gap: 50px;\n  margin-top: 8px;\n  border-radius: 8px;\n  border: 1px solid #ccc;\n  padding: 10px 15px;\n}\n\n/* Stack the role checkboxes on mobile so they aren't cramped side-by-side */\n@media (max-width: 768px) {\n  .checkboxGroup {\n    flex-direction: column;\n    gap: 14px;\n  }\n}\n\n.checkboxLabel {\n  display: flex;\n  align-items: center;\n  font-weight: normal;\n  cursor: pointer;\n}\n\n.checkboxLabel input {\n  width: auto;\n  margin-right: 8px;\n  cursor: pointer;\n}\n\n/* --- Modal Action Buttons (match the nav footer CTAs) --- */\n.submitButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 44px;\n  padding: 0 24px;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: var(--neutral-white);\n  background-color: var(--secondary-bright-blue);\n  border: 1px solid var(--secondary-bright-blue);\n}\n\n.submitButton:hover {\n  background-color: var(--primary-dark-blue);\n  border-color: var(--primary-dark-blue);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.submitButtonIcon {\n  font-size: 0.9em;\n}\n\n.secondaryButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 44px;\n  padding: 0 24px;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: var(--primary-dark-blue);\n  background-color: transparent;\n  border: 1px solid #dbe1e8;\n}\n\n.secondaryButton:hover {\n  background-color: #f0f4f8;\n}\n\n/* Balanced, finger-friendly footer buttons on mobile */\n@media (max-width: 768px) {\n  .submitButton,\n  .secondaryButton {\n    flex: 1;\n  }\n}\n\n/* --- Desktop Users Table (custom, lightweight) --- */\n.userTable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.95rem;\n}\n\n.userTable th {\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.8rem;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: #6c757d;\n  padding: 12px 14px;\n  background-color: #f7f9fb;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.userTable td {\n  padding: 14px;\n  border-bottom: 1px solid #eef0f2;\n  vertical-align: middle;\n  color: var(--primary-dark-blue);\n}\n\n.userTable tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.userTable tbody tr:hover {\n  background-color: #f7f9fb;\n}\n\n/* First/Last/Phone stay on a single line (V2-761) */\n.nameCell,\n.phoneCell {\n  white-space: nowrap;\n}\n\n.phoneCol,\n.phoneCell {\n  min-width: 150px;\n}\n\n.emailCell {\n  word-break: break-all;\n  overflow-wrap: anywhere;\n}\n\n.badgeStack {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  align-items: flex-start;\n}\n\n/* Actions column — icon buttons, clearly distinct from the status chips */\n.actionsCol {\n  width: 96px;\n}\n\n.rowActions {\n  display: flex;\n  gap: 6px;\n  justify-content: flex-end;\n}\n\n/* Filled icon buttons — edit = blue, delete = red (matching the mobile\n   card actions), and clearly distinct from the pill status chips */\n.iconButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: var(--neutral-white);\n  background-color: var(--secondary-bright-blue);\n  border: 1px solid var(--secondary-bright-blue);\n}\n\n.iconButton:hover {\n  background-color: var(--primary-dark-blue);\n  border-color: var(--primary-dark-blue);\n}\n\n.iconButtonDelete {\n  background-color: #e53e3e;\n  border-color: #e53e3e;\n}\n\n.iconButtonDelete:hover {\n  background-color: #c53030;\n  border-color: #c53030;\n}\n\n/* --- Mobile card action buttons (edit = blue, delete = red) --- */\n.cardActionButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 44px;\n  padding: 0 16px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: var(--neutral-white);\n  background-color: var(--secondary-bright-blue);\n  border: 1px solid var(--secondary-bright-blue);\n}\n\n.cardActionButton:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.cardActionButtonDelete {\n  background-color: #e53e3e;\n  border-color: #e53e3e;\n}\n\n.cardActionButtonDelete:hover {\n  background-color: #c53030;\n  border-color: #c53030;\n}\n\n/* --- Mobile User Cards (replaces the table on small screens) --- */\n.userCardList {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.userCard {\n  background-color: var(--neutral-white);\n  border: 1px solid #e0e0e0;\n  border-radius: 12px;\n  padding: 14px 16px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.userCardHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 10px;\n}\n\n.userCardName {\n  font-weight: 600;\n  font-size: 1.05rem;\n  color: var(--primary-dark-blue);\n  word-break: break-word;\n}\n\n.userCardBadges {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: flex-end;\n  flex-shrink: 0;\n}\n\n.userCardRow {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 5px 0;\n  font-size: 0.95rem;\n}\n\n.userCardLabel {\n  color: #6c757d;\n  flex-shrink: 0;\n}\n\n.userCardEmail {\n  word-break: break-all;\n  text-align: right;\n}\n\n.userCardActions {\n  display: flex;\n  gap: 10px;\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid #f0f0f0;\n}\n\n.userCardActions button {\n  flex: 1;\n}\n\n.emptyState {\n  text-align: center;\n  color: #6c757d;\n  font-size: 0.95rem;\n  padding: 28px 16px;\n  border: 1px dashed #d5d9e0;\n  border-radius: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepTitle": `AddUsers_stepTitle__Gqp9n`,
	"stepSubtitle": `AddUsers_stepSubtitle__2mmXa`,
	"tableContainer": `AddUsers_tableContainer__0MOjn`,
	"addUserButtonContainer": `AddUsers_addUserButtonContainer__JiPVQ`,
	"addUserButton": `AddUsers_addUserButton__trU0v`,
	"inputGrid": `AddUsers_inputGrid__2K4Uy`,
	"inputGroup": `AddUsers_inputGroup__gFC8A`,
	"errorMessage": `AddUsers_errorMessage__J9sth`,
	"inlineError": `AddUsers_inlineError__qlJFV ${___CSS_LOADER_ICSS_IMPORT_0___.locals["inlineError"]}`,
	"inlineErrorClose": `AddUsers_inlineErrorClose__kVqR3 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["inlineErrorClose"]}`,
	"checkboxGroup": `AddUsers_checkboxGroup__0NDXC`,
	"checkboxLabel": `AddUsers_checkboxLabel__rVHPY`,
	"submitButton": `AddUsers_submitButton__cXOjH`,
	"submitButtonIcon": `AddUsers_submitButtonIcon__GwOMv`,
	"secondaryButton": `AddUsers_secondaryButton__oojr5`,
	"userTable": `AddUsers_userTable__60q-0`,
	"nameCell": `AddUsers_nameCell__iwvbN`,
	"phoneCell": `AddUsers_phoneCell__cRwQB`,
	"phoneCol": `AddUsers_phoneCol__-X3fm`,
	"emailCell": `AddUsers_emailCell__-Mfjv`,
	"badgeStack": `AddUsers_badgeStack__NQmbJ`,
	"actionsCol": `AddUsers_actionsCol__5hODz`,
	"rowActions": `AddUsers_rowActions__XCYNi`,
	"iconButton": `AddUsers_iconButton__Rvav2`,
	"iconButtonDelete": `AddUsers_iconButtonDelete__ooyRY`,
	"cardActionButton": `AddUsers_cardActionButton__raCTC`,
	"cardActionButtonDelete": `AddUsers_cardActionButtonDelete__13+8Q`,
	"userCardList": `AddUsers_userCardList__-et8F`,
	"userCard": `AddUsers_userCard__IGeJu`,
	"userCardHeader": `AddUsers_userCardHeader__o4atk`,
	"userCardName": `AddUsers_userCardName__0q6q9`,
	"userCardBadges": `AddUsers_userCardBadges__e9Tgf`,
	"userCardRow": `AddUsers_userCardRow__JuMCY`,
	"userCardLabel": `AddUsers_userCardLabel__wZV-3`,
	"userCardEmail": `AddUsers_userCardEmail__0YqFh`,
	"userCardActions": `AddUsers_userCardActions__2OrOF`,
	"emptyState": `AddUsers_emptyState__5NREZ`
};
export default ___CSS_LOADER_EXPORT___;
